import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import type { DynamicInvoiceIdParams } from './use-dynamic-invoice-id-types/dynamic-invoice-id-params';

export function useParamsDynamicInvoiceId() {
  return useDynamicInvoiceId(undefined);
}

export function useParamsDynamicInvoiceIdOrDefault(defaultId: string | undefined) {
  return useDynamicInvoiceId(defaultId);
}

function useDynamicInvoiceId(defaultId: string | undefined) {
  const { customerId, invoiceId } = useParams<DynamicInvoiceIdParams>();
  const queryParamFallbackId = getQueryParamFallbackId();

  return useMemo(() => invoiceId ?? customerId ?? queryParamFallbackId ?? defaultId ?? '', [customerId, invoiceId, defaultId, queryParamFallbackId]);
}

function getQueryParamFallbackId() {
  return new URLSearchParams(window.location.search).get('invoiceId');
}